import React from 'react';
import PaymentGateway from './razorpay';

function Payment() {
  return (
    <div>
      <h2>Payment</h2>
      <PaymentGateway></PaymentGateway>
    </div>
  );
}       
export default Payment;